"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
var ServiceImplBase_1 = require("./ServiceImplBase");
var VisualModelServiceImpl = /** @class */ (function (_super) {
    __extends(VisualModelServiceImpl, _super);
    function VisualModelServiceImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VisualModelServiceImpl.prototype, "serviceName", {
        get: function () {
            return "visual-model-service" /* VisualModel */;
        },
        enumerable: true,
        configurable: true
    });
    VisualModelServiceImpl.prototype.getVisualSpecificationAsync = function (visualId) {
        var _a;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'getVisualSpecificationAsync',
            _a[api_internal_contract_js_1.ParameterId.WorksheetName] = visualId.worksheet,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.GetVisualSpecification, parameters).then(function (response) {
            var result = response.result;
            return result;
        });
    };
    VisualModelServiceImpl.prototype.addMarksCardFieldsAsync = function (visualId, marksCardIndex, encodingType, columns, startIndex) {
        var _a;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'addMarksCardFieldsAsync',
            _a[api_internal_contract_js_1.ParameterId.WorksheetName] = visualId.worksheet,
            _a[api_internal_contract_js_1.ParameterId.MarksCardIndex] = marksCardIndex,
            _a[api_internal_contract_js_1.ParameterId.EncodingType] = encodingType,
            _a[api_internal_contract_js_1.ParameterId.Columns] = columns,
            _a[api_internal_contract_js_1.ParameterId.StartIndex] = startIndex,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.AddMarksCardFields, parameters).then(function () {
            return;
        });
    };
    VisualModelServiceImpl.prototype.moveMarksCardFieldAsync = function (visualId, marksCardIndex, fromIndex, toIndex, fieldCount) {
        var _a;
        if (fieldCount === void 0) { fieldCount = 1; }
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'addMarksCardFieldsAsync',
            _a[api_internal_contract_js_1.ParameterId.WorksheetName] = visualId.worksheet,
            _a[api_internal_contract_js_1.ParameterId.MarksCardIndex] = marksCardIndex,
            _a[api_internal_contract_js_1.ParameterId.FromIndex] = fromIndex,
            _a[api_internal_contract_js_1.ParameterId.ToIndex] = toIndex,
            _a[api_internal_contract_js_1.ParameterId.FieldCount] = fieldCount,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.MoveMarksCardField, parameters).then(function () {
            return;
        });
    };
    VisualModelServiceImpl.prototype.spliceMarksCardFieldsAsync = function (visualId, marksCardIndex, encodingType, startIndex, deleteCount, columns) {
        var _a;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'spliceMarksCardFieldsAsync',
            _a[api_internal_contract_js_1.ParameterId.WorksheetName] = visualId.worksheet,
            _a[api_internal_contract_js_1.ParameterId.MarksCardIndex] = marksCardIndex,
            _a[api_internal_contract_js_1.ParameterId.EncodingType] = encodingType,
            _a[api_internal_contract_js_1.ParameterId.StartIndex] = startIndex,
            _a[api_internal_contract_js_1.ParameterId.DeleteCount] = deleteCount,
            _a[api_internal_contract_js_1.ParameterId.Columns] = columns,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.SpliceMarksCardFields, parameters).then(function () {
            return;
        });
    };
    VisualModelServiceImpl.prototype.editAliasesDialogAsync = function (fieldName) {
        var _a;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'editAliasesDialogAsync',
            _a[api_internal_contract_js_1.ParameterId.FieldId] = fieldName,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.EditAliasesDialog, parameters).then(function () {
            return;
        });
    };
    return VisualModelServiceImpl;
}(ServiceImplBase_1.ServiceImplBase));
exports.VisualModelServiceImpl = VisualModelServiceImpl;
//# sourceMappingURL=VisualModelServiceImpl.js.map